import { render, staticRenderFns } from "./userBossList.vue?vue&type=template&id=69c28169"
import script from "./userBossList.vue?vue&type=script&lang=js"
export * from "./userBossList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports